'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Location = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _icons = require('constants/icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Location = exports.Location = function (_PureComponent) {
  (0, _inherits3.default)(Location, _PureComponent);

  function Location() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, Location);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = Location.__proto__ || (0, _getPrototypeOf2.default)(Location)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleRemoveClick = function (event) {
      event.stopPropagation();

      var _this$props = _this.props,
          searchId = _this$props.searchId,
          onRemoveClick = _this$props.onRemoveClick;


      onRemoveClick(searchId);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(Location, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          highlighted = _props.highlighted,
          onRemoveClick = _props.onRemoveClick,
          searchId = _props.searchId,
          item = _props.item,
          rest = (0, _objectWithoutProperties3.default)(_props, ['highlighted', 'onRemoveClick', 'searchId', 'item']);


      return _react2.default.createElement(
        'li',
        (0, _extends3.default)({
          className: (0, _classnames2.default)('dropdown__item', {
            'dropdown__item--highlighted': highlighted
          })
        }, rest),
        _react2.default.createElement(_reactInlinesvg2.default, { className: 'dropdown__item__icon', src: _icons.LOCATION_ICONS.location_pin }),
        _react2.default.createElement(
          'div',
          { className: 'dropdown__item__content' },
          item.main_text ? _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
              'strong',
              null,
              item.main_text
            ),
            ' ',
            item.secondary_text
          ) : item.secondary_text
        ),
        searchId && _react2.default.createElement(
          'div',
          { className: 'dropdown__item__remove', onClick: this.handleRemoveClick },
          'x'
        )
      );
    }
  }]);
  return Location;
}(_react.PureComponent);

Location.propTypes = {
  highlighted: _propTypes2.default.bool.isRequired,
  onRemoveClick: _propTypes2.default.func.isRequired,
  item: _propTypes2.default.shape({
    main_text: _propTypes2.default.string.isRequired,
    secondary_text: _propTypes2.default.string.isRequired
  }).isRequired,
  searchId: _propTypes2.default.string
};